// This file is generated by the createModsData.js script.
// Do not manually make changes to this file because they will be overridden
// This file uses a custom data structure specific to the Mods page

export default [
  {
    name: "Armor Mods",
    sets: [
      {
        name: "Helmet",
        big: false,
        sections: [
          {
            name: "Any",
            nameHash: 1198124803,
            itemGroups: [
              [
                2524985605, // Kinetic Siphon
                212107599 // Harmonic Siphon
              ],
              [
                1324233022, // Scout and Sniper Rifle Targeting
                1404465541, // Inferno Whip
                1324233023, // Bottomless Bounty I
                2187989976, // Bottomless Bounty II
              ],
              [
                1624081088, // Bow Ammo Finder
                3394151347, // Fusion Rifle Ammo Finder
                755265365, // Grenade Launcher Ammo Finder
                650047261, // Hand Cannon Ammo Finder
                2128395292, // Machine Gun Ammo Finder
                1499759470, // Linear Fusion Rifle Ammo Finder
                2603856295, // Rocket Launcher Ammo Finder
                4148827738, // Shotgun Ammo Finder
                1050260245, // Sidearm Ammo Finder
                2754084930, // Sniper Rifle Ammo Finder
                1476367343, // Sword Ammo Finder
                3973928133, // Trace Rifle Ammo Finder
                712951940 // Glaive Ammo Finder
              ],
              [
                3201675491, // Auto Rifle Targeting
                2080519917, // Bow Targeting
                3901392720, // Fusion Rifle Targeting
                2829974286, // Hand Cannon Targeting
                1015337793, // Machine Gun Targeting
                3338875786, // Linear Fusion Rifle Targeting
                3319681729, // Pulse Rifle Targeting
                631976966, // Scout Rifle Targeting
                2919349723, // Shotgun Targeting
                1507854082, // Sidearm Targeting
                3857411140, // Submachine Gun Targeting
                2307244871, // Sniper Rifle Targeting
                3330325954, // Trace Rifle Targeting
                3109470977 // Glaive Targeting
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  2524985605, // Kinetic Siphon
                  212107599 // Harmonic Siphon
                ]
              },
              {
                name: "Seasonal Artifact",
                items: [
                  1324233022, // Scout and Sniper Rifle Targeting
                  1404465541, // Inferno Whip
                  1324233023, // Bottomless Bounty I
                  2187989976, // Bottomless Bounty II
                ]
              },
              {
                name: "Ammo Finder",
                items: [
                  1624081088, // Bow Ammo Finder
                  3394151347, // Fusion Rifle Ammo Finder
                  755265365, // Grenade Launcher Ammo Finder
                  650047261, // Hand Cannon Ammo Finder
                  2128395292, // Machine Gun Ammo Finder
                  1499759470, // Linear Fusion Rifle Ammo Finder
                  2603856295, // Rocket Launcher Ammo Finder
                  4148827738, // Shotgun Ammo Finder
                  1050260245, // Sidearm Ammo Finder
                  2754084930, // Sniper Rifle Ammo Finder
                  1476367343, // Sword Ammo Finder
                  3973928133, // Trace Rifle Ammo Finder
                  712951940 // Glaive Ammo Finder
                ]
              },
              {
                name: "Targeting",
                items: [
                  3201675491, // Auto Rifle Targeting
                  2080519917, // Bow Targeting
                  3901392720, // Fusion Rifle Targeting
                  2829974286, // Hand Cannon Targeting
                  1015337793, // Machine Gun Targeting
                  3338875786, // Linear Fusion Rifle Targeting
                  3319681729, // Pulse Rifle Targeting
                  631976966, // Scout Rifle Targeting
                  2919349723, // Shotgun Targeting
                  1507854082, // Sidearm Targeting
                  3857411140, // Submachine Gun Targeting
                  2307244871, // Sniper Rifle Targeting
                  3330325954, // Trace Rifle Targeting
                  3109470977 // Glaive Targeting
                ]
              }
            ]
          },
          {
            name: "Arc",
            nameHash: 728351493,
            itemGroups: [
              [
                3065699930, // Hands-On
                3899134858 // Arc Siphon
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3065699930, // Hands-On
                  3899134858 // Arc Siphon
                ]
              }
            ]
          },
          {
            name: "Solar",
            nameHash: 591714140,
            itemGroups: [
              [
                322752304, // Ashes to Assets
                2999890939 // Solar Siphon
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  322752304, // Ashes to Assets
                  2999890939 // Solar Siphon
                ]
              }
            ]
          },
          {
            name: "Void",
            nameHash: 4069572561,
            itemGroups: [
              [
                1016705548, // Dynamo
                1038135636 // Void Siphon
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1016705548, // Dynamo
                  1038135636 // Void Siphon
                ]
              }
            ]
          },
          {
            name: "Stasis",
            nameHash: 1819698290,
            itemGroups: [
              [
                3638321667, // Power Preservation
                3825575169 // Stasis Siphon
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3638321667, // Power Preservation
                  3825575169 // Stasis Siphon
                ]
              }
            ]
          }
        ]
      },
      {
        name: "Arms",
        big: false,
        sections: [
          {
            name: "Any",
            nameHash: 1198124803,
            itemGroups: [
              [
                403494087 // Fastball
              ],
              [
                3521781038, // Overload Bow
                3521781037, // Unstoppable Pulse Rifle
                3521781036, // Anti-Barrier Scout Rifle
                3521781035, // Anti-Barrier Auto Rifle
                3521781034, // Unstoppable Shotgun
                1324233019, // Scout Rifle Loader
                2187989980, // Glaive Loader
                2187989983, // Focusing Strike
                1404465537, // Overload Machine Guns
                1404465538, // Anti-Barrier Sniper Rifle
              ],
              [
                2571974065, // Auto Rifle Loader
                3436675785, // Bow Reloader
                428274928, // Fusion Rifle Loader
                4140815674, // Grenade Launcher Loader
                1052494884, // Hand Cannon Loader
                157329321, // Machine Gun Loader
                178399816, // Linear Fusion Rifle Loader
                1129724921, // Pulse Rifle Loader
                2324400338, // Rocket Launcher Loader
                667313240, // Scout Rifle Loader
                1534061443, // Shotgun Loader
                762238512, // Sidearm Loader
                2790645726, // Submachine Gun Loader
                2039949393, // Sniper Rifle Loader
                1807758212, // Trace Rifle Loader
                1600896643 // Glaive Loader
              ],
              [
                100050722, // Auto Rifle Dexterity
                1621596154, // Bow Dexterity
                3517390997, // Fusion Rifle Dexterity
                3038929059, // Grenade Launcher Dexterity
                2192962617, // Hand Cannon Dexterity
                1740875866, // Machine Gun Dexterity
                1445862797, // Linear Fusion Dexterity
                3228149706, // Pulse Rifle Dexterity
                1970413851, // Rocket Launcher Dexterity
                3337174653, // Scout Rifle Dexterity
                235706376, // Shotgun Dexterity
                2353976789, // Sidearm Dexterity
                459449847, // Submachine Gun Dexterity
                146553282, // Sniper Rifle Dexterity
                532451225, // Trace Rifle Dexterity
                3725144328, // Glaive Dexterity
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  403494087 // Fastball
                ]
              },
              {
                name: "Seasonal Artifact",
                items: [
                  3521781038, // Overload Bow
                  3521781037, // Unstoppable Pulse Rifle
                  3521781036, // Anti-Barrier Scout Rifle
                  3521781035, // Anti-Barrier Auto Rifle
                  3521781034, // Unstoppable Shotgun
                  1324233019, // Scout Rifle Loader
                  2187989980, // Glaive Loader
                  2187989983, // Focusing Strike
                  1404465537, // Overload Machine Guns
                  1404465538, // Anti-Barrier Sniper Rifle
                ]
              },
              {
                name: "Loaders",
                items: [
                  2571974065, // Auto Rifle Loader
                  3436675785, // Bow Reloader
                  428274928, // Fusion Rifle Loader
                  4140815674, // Grenade Launcher Loader
                  1052494884, // Hand Cannon Loader
                  157329321, // Machine Gun Loader
                  178399816, // Linear Fusion Rifle Loader
                  1129724921, // Pulse Rifle Loader
                  2324400338, // Rocket Launcher Loader
                  667313240, // Scout Rifle Loader
                  1534061443, // Shotgun Loader
                  762238512, // Sidearm Loader
                  2790645726, // Submachine Gun Loader
                  2039949393, // Sniper Rifle Loader
                  1807758212, // Trace Rifle Loader
                  1600896643 // Glaive Loader
                ]
              },
              {
                name: "Dexterity",
                items: [
                  100050722, // Auto Rifle Dexterity
                  1621596154, // Bow Dexterity
                  3517390997, // Fusion Rifle Dexterity
                  3038929059, // Grenade Launcher Dexterity
                  2192962617, // Hand Cannon Dexterity
                  1740875866, // Machine Gun Dexterity
                  1445862797, // Linear Fusion Dexterity
                  3228149706, // Pulse Rifle Dexterity
                  1970413851, // Rocket Launcher Dexterity
                  3337174653, // Scout Rifle Dexterity
                  235706376, // Shotgun Dexterity
                  2353976789, // Sidearm Dexterity
                  459449847, // Submachine Gun Dexterity
                  146553282, // Sniper Rifle Dexterity
                  532451225, // Trace Rifle Dexterity
                  3725144328, // Glaive Dexterity
                ]
              }
            ]
          },
          {
            name: "Arc",
            nameHash: 728351493,
            itemGroups: [
              [
                3788210493 // Momentum Transfer
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3788210493 // Momentum Transfer
                ]
              }
            ]
          },
          {
            name: "Solar",
            nameHash: 591714140,
            itemGroups: [
              [
                3470562293 // Impact Induction
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3470562293 // Impact Induction
                ]
              }
            ]
          },
          {
            name: "Void",
            nameHash: 4069572561,
            itemGroups: [
              [
                1839911272, // Focusing Strike
                3750579462 // Bolstering Detonation
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1839911272, // Focusing Strike
                  3750579462 // Bolstering Detonation
                ]
              }
            ]
          },
          {
            name: "Stasis",
            nameHash: 1819698290,
            itemGroups: [
              [
                47859594, // Grenade Kickstart
                1371877916 // Melee Kickstart
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  47859594, // Grenade Kickstart
                  1371877916 // Melee Kickstart
                ]
              }
            ]
          }
        ]
      },
      {
        name: "Chest",
        big: false,
        sections: [
          {
            name: "Any",
            nameHash: 1198124803,
            itemGroups: [
              [
                2588939505, // Concussive Dampener
                760472183, // Melee Damage Resistance
                3566745556 // Sniper Damage Resistance
              ],
              [
                2187989982, // Thermoshock Plating
              ],
              [
                201502208, // Bow Reserves
                3531950723, // Fusion Rifle Reserves
                3330921441, // Grenade Launcher Reserves
                1043617959, // Hand Cannon Reserves
                3188535145, // Machine Gun Reserves
                749060462, // Linear Fusion Rifle Reserves
                1303690937, // Rocket Launcher Reserves
                2368162286, // Shotgun Reserves
                3859610803, // Sidearm Reserves
                3926976952, // Sniper Rifle Reserves
                3543966269, // Sword Reserves
                2321484659, // Trace Rifle Reserves
                950703238 // Glaive Reserves
              ],
              [
                2505824339, // Unflinching Auto Rifle Aim
                3662638763, // Unflinching Bow Aim
                3121039270, // Unflinching Fusion Rifle Aim
                807774340, // Unflinching Grenade Launcher Aim
                1859929470, // Unflinching Hand Cannon Aim
                3091213995, // Unflinching Machine Gun
                650627622, // Unflinching Linear Fusion Aim
                2379452959, // Unflinching Pulse Rifle Aim
                1279446438, // Unflinching Scout Rifle Aim
                357349821, // Unflinching Shotgun Aim
                2881057950, // Unflinching Sidearm Aim
                1203395203, // Unflinching Sniper Aim
                3626376648, // Unflinching Submachine Gun Aim
                4023967480, // Unflinching Trace Rifle Aim
                1406211233 // Unflinching Glaive Aim
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  2588939505, // Concussive Dampener
                  760472183, // Melee Damage Resistance
                  3566745556 // Sniper Damage Resistance
                ]
              },
              {
                name: "Seasonal Artifact",
                items: [
                  2187989982, // Thermoshock Plating
                ]
              },
              {
                name: "Ammo Reserves",
                items: [
                  201502208, // Bow Reserves
                  3531950723, // Fusion Rifle Reserves
                  3330921441, // Grenade Launcher Reserves
                  1043617959, // Hand Cannon Reserves
                  3188535145, // Machine Gun Reserves
                  749060462, // Linear Fusion Rifle Reserves
                  1303690937, // Rocket Launcher Reserves
                  2368162286, // Shotgun Reserves
                  3859610803, // Sidearm Reserves
                  3926976952, // Sniper Rifle Reserves
                  3543966269, // Sword Reserves
                  2321484659, // Trace Rifle Reserves
                  950703238 // Glaive Reserves
                ]
              },
              {
                name: "Unflinching Aim",
                items: [
                  2505824339, // Unflinching Auto Rifle Aim
                  3662638763, // Unflinching Bow Aim
                  3121039270, // Unflinching Fusion Rifle Aim
                  807774340, // Unflinching Grenade Launcher Aim
                  1859929470, // Unflinching Hand Cannon Aim
                  3091213995, // Unflinching Machine Gun
                  650627622, // Unflinching Linear Fusion Aim
                  2379452959, // Unflinching Pulse Rifle Aim
                  1279446438, // Unflinching Scout Rifle Aim
                  357349821, // Unflinching Shotgun Aim
                  2881057950, // Unflinching Sidearm Aim
                  1203395203, // Unflinching Sniper Aim
                  3626376648, // Unflinching Submachine Gun Aim
                  4023967480, // Unflinching Trace Rifle Aim
                  1406211233 // Unflinching Glaive Aim
                ]
              }
            ]
          },
          {
            name: "Arc",
            nameHash: 728351493,
            itemGroups: [
              [
                3074491624 // Arc Resistance
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3074491624 // Arc Resistance
                ]
              }
            ]
          },
          {
            name: "Solar",
            nameHash: 591714140,
            itemGroups: [
              [
                1429600943 // Solar Resistance
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1429600943 // Solar Resistance
                ]
              }
            ]
          },
          {
            name: "Void",
            nameHash: 4069572561,
            itemGroups: [
              [
                107977982 // Void Resistance
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  107977982 // Void Resistance
                ]
              }
            ]
          },
          {
            name: "Stasis",
            nameHash: 1819698290,
            itemGroups: [
              [
                3176563510 // Stasis Resistance
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3176563510 // Stasis Resistance
                ]
              }
            ]
          }
        ]
      },
      {
        name: "Legs",
        big: false,
        sections: [
          {
            name: "Any",
            nameHash: 1198124803,
            itemGroups: [
              [
                1207025932 // Absolution
              ],
              [
                1324233016, // Sword Scavenger
                1324233017, // Machine Gun Holster
                2187989977, // Machine Gun Scavenger
              ],
              [
                987267082, // Arrow Scavenger
                2347686425, // Fusion Rifle Scavenger
                3670960347, // Grenade Launcher Scavenger
                2758832455, // Hand Cannon Scavenger
                1559280270, // Machine Gun Scavenger
                2051366208, // Linear Fusion Rifle Scavenger
                311492789, // Rocket Launcher Scavenger
                3836152936, // Shotgun Scavenger
                2183342667, // Sidearm Scavenger
                498878196, // Sniper Rifle Scavenger
                2146553541, // Sword Scavenger
                3632415743, // Trace Rifle Scavenger
                155500646 // Glaive Scavenger
              ],
              [
                96170281, // Auto Rifle Holster
                107499324, // Fusion Rifle Holster
                2627515934, // Grenade Launcher Holster
                3759707664, // Hand Cannon Holster
                // 2979161761, // Hand Cannon Holster - Duplicate that isn't earnable
                1127642993, // Machine Gun Holster
                2238903692, // Linear Fusion Rifle Holster
                2001283033, // Pulse Rifle Holster
                2356995028, // Scout Rifle Holster
                2395653827, // Shotgun Holster
                2982054284, // Sidearm Holster
                3563461386, // Submachine Gun Holster
                1597311617, // Sniper Rifle Holster
                320966913, // Trace Rifle Holster
                681555689 // Glaive Holster
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1207025932 // Absolution
                ]
              },
              {
                name: "Seasonal Artifact",
                items: [
                  1324233016, // Sword Scavenger
                  1324233017, // Machine Gun Holster
                  2187989977, // Machine Gun Scavenger
                ]
              },
              {
                name: "Ammo Scavenger",
                items: [
                  987267082, // Arrow Scavenger
                  2347686425, // Fusion Rifle Scavenger
                  3670960347, // Grenade Launcher Scavenger
                  2758832455, // Hand Cannon Scavenger
                  1559280270, // Machine Gun Scavenger
                  2051366208, // Linear Fusion Rifle Scavenger
                  311492789, // Rocket Launcher Scavenger
                  3836152936, // Shotgun Scavenger
                  2183342667, // Sidearm Scavenger
                  498878196, // Sniper Rifle Scavenger
                  2146553541, // Sword Scavenger
                  3632415743, // Trace Rifle Scavenger
                  155500646 // Glaive Scavenger
                ]
              },
              {
                name: "Holster",
                items: [
                  96170281, // Auto Rifle Holster
                  107499324, // Fusion Rifle Holster
                  2627515934, // Grenade Launcher Holster
                  3759707664, // Hand Cannon Holster
                  // 2979161761, // Hand Cannon Holster - Duplicate that isn't earnable
                  1127642993, // Machine Gun Holster
                  2238903692, // Linear Fusion Rifle Holster
                  2001283033, // Pulse Rifle Holster
                  2356995028, // Scout Rifle Holster
                  2395653827, // Shotgun Holster
                  2982054284, // Sidearm Holster
                  3563461386, // Submachine Gun Holster
                  1597311617, // Sniper Rifle Holster
                  320966913, // Trace Rifle Holster
                  681555689 // Glaive Holster
                ]
              }
            ]
          },
          {
            name: "Arc",
            nameHash: 728351493,
            itemGroups: [
              [
                2799168657 // Invigoration
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  2799168657 // Invigoration
                ]
              }
            ]
          },
          {
            name: "Solar",
            nameHash: 591714140,
            itemGroups: [
              [
                1921961414, // Recuperation
                380905615 // Innervation
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1921961414, // Recuperation
                  380905615 // Innervation
                ]
              }
            ]
          },
          {
            name: "Void",
            nameHash: 4069572561,
            itemGroups: [
              [
                1324869195, // Better Already
                703340600 // Insulation
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1324869195, // Better Already
                  703340600 // Insulation
                ]
              }
            ]
          },
          {
            name: "Stasis",
            nameHash: 1819698290,
            itemGroups: [
              [
                1985887424 // Orbs of Restoration
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1985887424 // Orbs of Restoration
                ]
              }
            ]
          }
        ]
      },
      {
        name: "Class item",
        big: false,
        sections: [
          {
            name: "Any",
            nameHash: 1198124803,
            itemGroups: [
              [
                1513970148, // Distribution
                4237638090, // Special Finisher
                4237638094 // Snapload Finisher
              ],
              [
                1404465539, // Bad Amplitude
                1404465540, // Surge Detonators
                3778343682, // Thunderous Retort
                3778343681, // Amped Up
                3778343680, // Trace Evidence
                3778343687, // Lightning Strikes Twice
                3778343686, // Sundering Glare
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  1513970148, // Distribution
                  4237638090, // Special Finisher
                  4237638094 // Snapload Finisher
                ]
              },
              {
                name: "Seasonal Artifact",
                items: [
                  1404465539, // Bad Amplitude
                  1404465540, // Surge Detonators
                  3778343682, // Thunderous Retort
                  3778343681, // Amped Up
                  3778343680, // Trace Evidence
                  3778343687, // Lightning Strikes Twice
                  3778343686, // Sundering Glare
                ]
              }
            ]
          },
          {
            name: "Arc",
            nameHash: 728351493,
            itemGroups: [
              [
                3974455041, // Outreach
                4237638091 // One-Two Finisher
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3974455041, // Outreach
                  4237638091 // One-Two Finisher
                ]
              }
            ]
          },
          {
            name: "Solar",
            nameHash: 591714140,
            itemGroups: [
              [
                3561960031, // Bomber
                4237638089, // Healthy Finisher
                4237638095 // Explosive Finisher
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  3561960031, // Bomber
                  4237638089, // Healthy Finisher
                  4237638095 // Explosive Finisher
                ]
              }
            ]
          },
          {
            name: "Void",
            nameHash: 4069572561,
            itemGroups: [
              [
                4137020505, // Perpetuation
                4237638088, // Bulwark Finisher
                4055766573 // Utility Finisher
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  4137020505, // Perpetuation
                  4237638088, // Bulwark Finisher
                  4055766573 // Utility Finisher
                ]
              }
            ]
          },
          {
            name: "Stasis",
            nameHash: 1819698290,
            itemGroups: [
              [
                445559589, // Utility Kickstart
                958741637 // Restorative Finisher
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  445559589, // Utility Kickstart
                  958741637 // Restorative Finisher
                ]
              }
            ]
          }
        ]
      },
      {
        name: "Universal",
        big: true,
        sections: [
          {
            name: "Any",
            nameHash: 1198124803,
            itemGroups: [
              [
                4048838440, // Discipline Mod
                3253038666, // Strength Mod
                3355995799, // Intellect Mod
                3961599962, // Mobility Mod
                2645858828, // Recovery Mod
                2850583378, // Resilience Mod
                2623485440, // Minor Discipline Mod
                3699676109, // Minor Strength Mod
                1227870362, // Minor Intellect Mod
                204137529, // Minor Mobility Mod
                555005975, // Minor Recovery Mod
                3682186345 // Minor Resilience Mod
              ],
              [
                2859541905, // Taken Armaments
                399528760, // Taken Invigoration
                3570105787, // Taken Barrier
                2589105944 // Taken Repurposing
              ],
              [
                3895804619 // Dreambane Mod
              ],
              [
                3630287380, // Enhanced Relay Defender
                3415291596 // Relay Defender
              ],
              [
                3632726238, // Taking Charge
                3632726239, // Shield Break Charge
                3632726236, // Empowered Finish
                3632726237 // High-Energy Fire
              ],
              [
                179977572 // Global Reach
              ],
              [
                2142852459 // Herd Thinner
              ],
              [
                1824486242, // Elemental Ordnance
                2823326549, // Elemental Light
                1515669996, // Elemental Armaments
                1740246051, // Font of Might
                1196831979, // Font of Wisdom
                3730619869, // Elemental Charge
                1052528480, // Shieldcrash Wellmaker
                4213142382 // Melee Wellmaker
              ],
              [
                2725575870, // Anti-Oracle
                2725575871 // Anti-Praetorian
              ],
              [
                2804214704 // Umbral Sharpening
              ],
              [
                1291268263, // Mortal Medicine
                1291268261, // Old Gods' Boon
                1291268262, // Run for Your Life
                1291268260, // Will of Light (Kinetic)
              ]
            ],
            groups: [
              {
                name: "General",
                items: [
                  4048838440, // Discipline Mod
                  3253038666, // Strength Mod
                  3355995799, // Intellect Mod
                  3961599962, // Mobility Mod
                  2645858828, // Recovery Mod
                  2850583378, // Resilience Mod
                  2623485440, // Minor Discipline Mod
                  3699676109, // Minor Strength Mod
                  1227870362, // Minor Intellect Mod
                  204137529, // Minor Mobility Mod
                  555005975, // Minor Recovery Mod
                  3682186345 // Minor Resilience Mod
                ]
              },
              {
                name: "Last Wish",
                items: [
                  2859541905, // Taken Armaments
                  399528760, // Taken Invigoration
                  3570105787, // Taken Barrier
                  2589105944 // Taken Repurposing
                ]
              },
              {
                name: "Season of the Undying",
                items: [
                  3895804619 // Dreambane Mod
                ]
              },
              {
                name: "Garden of Salvation",
                items: [
                  3630287380, // Enhanced Relay Defender
                  3415291596 // Relay Defender
                ]
              },
              {
                name: "Season of Dawn",
                items: [
                  3632726238, // Taking Charge
                  3632726239, // Shield Break Charge
                  3632726236, // Empowered Finish
                  3632726237 // High-Energy Fire
                ]
              },
              {
                name: "Season of the Worthy",
                items: [
                  179977572 // Global Reach
                ]
              },
              {
                name: "Deep Stone Crypt",
                items: [
                  2142852459 // Herd Thinner
                ]
              },
              {
                name: "H.E.L.M.",
                items: [
                  1824486242, // Elemental Ordnance
                  2823326549, // Elemental Light
                  1515669996, // Elemental Armaments
                  1740246051, // Font of Might
                  1196831979, // Font of Wisdom
                  3730619869, // Elemental Charge
                  1052528480, // Shieldcrash Wellmaker
                  4213142382 // Melee Wellmaker
                ]
              },
              {
                name: "Vault of Glass",
                items: [
                  2725575870, // Anti-Oracle
                  2725575871 // Anti-Praetorian
                ]
              },
              {
                name: "Vow of the Disciple",
                items: [
                  2804214704 // Umbral Sharpening
                ]
              },
              {
                name: "King's Fall",
                items: [
                  1291268263, // Mortal Medicine
                  1291268261, // Old Gods' Boon
                  1291268262, // Run for Your Life
                  1291268260, // Will of Light (Kinetic)
                ],
              },
            ]
          },
          {
            name: "Arc",
            nameHash: 728351493,
            itemGroups: [
              [
                3829100654, // Supreme Nightmare Banisher
                1996040463, // Enhanced Nightmare Banisher
                2874957617 // Nightmare Banisher
              ],
              [
                2037533514, // Enhanced Resistant Tether
                2887845822 // Resistant Tether
              ],
              [
                1484685884, // Quick Charge
                1484685885, // Striking Light
                1484685886, // Heavy Handed
                1484685887 // Powerful Friends
              ],
              [
                179977573, // Blessing of Rasputin
                179977575, // Warmind's Light
                1789319806, // Modular Lightning
                1789319807, // Strength of Rasputin
                1789319804, // Sheltering Energy
                1789319805 // Chosen of the Warmind
              ],
              [
                2979815164, // Swift Charge
                2979815165, // Lucent Blade
                2979815166, // Reactive Pulse
                2979815167 // Radiant Light
              ],
              [
                1578165808 // Enhanced Scanner Augment
              ],
              [
                3097132144, // Overcharge Wellmaker
                1680735357, // Well of Ions
                4044800076, // Well of Striking
                4044800077 // Seeking Wells
              ],
              [
                4076776732, // Rapid Oracle Disruptor
                4076776733, // Vex Breaker
                4076776734 // Superstructure Striker
              ],
              [
                3922904113, // Umbral Hastening
                3808234135 // Shocked Glyphkeeper
              ],
              [
                3643044286, // Will of Light (Arc)
              ],
            ],
            groups: [
              {
                name: "Season of the Undying",
                items: [
                  3829100654, // Supreme Nightmare Banisher
                  1996040463, // Enhanced Nightmare Banisher
                  2874957617 // Nightmare Banisher
                ]
              },
              {
                name: "Garden of Salvation",
                items: [
                  2037533514, // Enhanced Resistant Tether
                  2887845822 // Resistant Tether
                ]
              },
              {
                name: "Season of Dawn",
                items: [
                  1484685884, // Quick Charge
                  1484685885, // Striking Light
                  1484685886, // Heavy Handed
                  1484685887 // Powerful Friends
                ]
              },
              {
                name: "Season of the Worthy",
                items: [
                  179977573, // Blessing of Rasputin
                  179977575, // Warmind's Light
                  1789319806, // Modular Lightning
                  1789319807, // Strength of Rasputin
                  1789319804, // Sheltering Energy
                  1789319805 // Chosen of the Warmind
                ]
              },
              {
                name: "Season of Arrivals",
                items: [
                  2979815164, // Swift Charge
                  2979815165, // Lucent Blade
                  2979815166, // Reactive Pulse
                  2979815167 // Radiant Light
                ]
              },
              {
                name: "Deep Stone Crypt",
                items: [
                  1578165808 // Enhanced Scanner Augment
                ]
              },
              {
                name: "H.E.L.M.",
                items: [
                  3097132144, // Overcharge Wellmaker
                  1680735357, // Well of Ions
                  4044800076, // Well of Striking
                  4044800077 // Seeking Wells
                ]
              },
              {
                name: "Vault of Glass",
                items: [
                  4076776732, // Rapid Oracle Disruptor
                  4076776733, // Vex Breaker
                  4076776734 // Superstructure Striker
                ]
              },
              {
                name: "Vow of the Disciple",
                items: [
                  3922904113, // Umbral Hastening
                  3808234135 // Shocked Glyphkeeper
                ]
              },
              {
                name: "King's Fall",
                items: [
                  3643044286, // Will of Light (Arc)
                ],
              },
            ]
          },
          {
            name: "Solar",
            nameHash: 591714140,
            itemGroups: [
              [
                2023980600, // Supreme Nightmare Breaker
                4193902249, // Enhanced Nightmare Breaker
                1560574695 // Nightmare Breaker
              ],
              [
                4020036031, // Enhanced Voltaic Ammo Collector
                928186993 // Voltaic Ammo Collector
              ],
              [
                3185435909, // Heal Thyself
                3185435908, // Firepower
                3185435911, // Blast Radius
                3185435910 // Charged Up
              ],
              [
                179977574, // Light of the Fire
                2216063963, // Burning Cells
                2216063962, // Wrath of Rasputin
                2216063961, // Fireteam Medic
                2216063960, // Rage of the Warmind
                2216063967 // Incinerating Light
              ],
              [
                4272180933, // Sustained Charge
                4272180932, // Argent Ordnance
                4272180935, // Kindling the Flame
                4272180934 // Supercharged
              ],
              [
                817361141 // Enhanced Operator Augment
              ],
              [
                825650462, // Explosive Wellmaker
                2164090163, // Well of Life
                4288515061, // Well of Ordnance
                4288515060 // Bountiful Wells
              ],
              [
                1401506405, // Aggressive Oracle Disruptor
                1401506404, // Vex Destroyer
                1401506407 // Superstructure Medic
              ],
              [
                4230067633, // Into the Light
                2851458940 // Smoldering Glyphkeeper
              ],
              [
                3540739611, // Will of Light (Solar)
              ],
            ],
            groups: [
              {
                name: "Season of the Undying",
                items: [
                  2023980600, // Supreme Nightmare Breaker
                  4193902249, // Enhanced Nightmare Breaker
                  1560574695 // Nightmare Breaker
                ]
              },
              {
                name: "Garden of Salvation",
                items: [
                  4020036031, // Enhanced Voltaic Ammo Collector
                  928186993 // Voltaic Ammo Collector
                ]
              },
              {
                name: "Season of Dawn",
                items: [
                  3185435909, // Heal Thyself
                  3185435908, // Firepower
                  3185435911, // Blast Radius
                  3185435910 // Charged Up
                ]
              },
              {
                name: "Season of the Worthy",
                items: [
                  179977574, // Light of the Fire
                  2216063963, // Burning Cells
                  2216063962, // Wrath of Rasputin
                  2216063961, // Fireteam Medic
                  2216063960, // Rage of the Warmind
                  2216063967 // Incinerating Light
                ]
              },
              {
                name: "Season of Arrivals",
                items: [
                  4272180933, // Sustained Charge
                  4272180932, // Argent Ordnance
                  4272180935, // Kindling the Flame
                  4272180934 // Supercharged
                ]
              },
              {
                name: "Deep Stone Crypt",
                items: [
                  817361141 // Enhanced Operator Augment
                ]
              },
              {
                name: "H.E.L.M.",
                items: [
                  825650462, // Explosive Wellmaker
                  2164090163, // Well of Life
                  4288515061, // Well of Ordnance
                  4288515060 // Bountiful Wells
                ]
              },
              {
                name: "Vault of Glass",
                items: [
                  1401506405, // Aggressive Oracle Disruptor
                  1401506404, // Vex Destroyer
                  1401506407 // Superstructure Medic
                ]
              },
              {
                name: "Vow of the Disciple",
                items: [
                  4230067633, // Into the Light
                  2851458940 // Smoldering Glyphkeeper
                ]
              },
              {
                name: "King's Fall",
                items: [
                  3540739611, // Will of Light (Solar)
                ],
              },
            ]
          },
          {
            name: "Void",
            nameHash: 4069572561,
            itemGroups: [
              [
                2045123179, // Supreme Nightmare Crusher
                1565861116, // Enhanced Nightmare Crusher
                3736152098 // Nightmare Crusher
              ],
              [
                865380761, // Enhanced Voltaic Mote Collector
                4134680615 // Voltaic Mote Collector
              ],
              [
                3523075120, // Protective Light
                3523075121, // Extra Reserves
                3523075122, // Precisely Charged
                3523075123 // Stacks on Stacks
              ],
              [
                179977568, // Grasp of the Warmind
                2597888510, // Cellular Suppression
                2597888511, // Power of Rasputin
                2597888508, // Warmind's Protection
                2597888509, // Warmind's Longevity
                2597888506 // Light from Darkness
              ],
              [
                2263321584, // Precision Charge
                2263321585, // Surprise Attack
                2263321586, // Energy Converter
                2263321587 // Charge Harvester
              ],
              [
                1362793604 // Enhanced Suppressor Augment
              ],
              [
                240958661, // Reaping Wellmaker
                3809244044, // Well of Tenacity
                1358633824, // Well of Utility
                1358633825 // Enduring Wells
              ],
              [
                518521232, // Precise Oracle Disruptor
                518521233, // Vex Striker
                518521234 // Superstructure Defender
              ],
              [
                1956421814, // Umbral Recharge
                1098978103 // Distorted Glyphkeeper
              ],
              [
                852793406, // Will of Light (Void)
              ],
            ],
            groups: [
              {
                name: "Season of the Undying",
                items: [
                  2045123179, // Supreme Nightmare Crusher
                  1565861116, // Enhanced Nightmare Crusher
                  3736152098 // Nightmare Crusher
                ]
              },
              {
                name: "Garden of Salvation",
                items: [
                  865380761, // Enhanced Voltaic Mote Collector
                  4134680615 // Voltaic Mote Collector
                ]
              },
              {
                name: "Season of Dawn",
                items: [
                  3523075120, // Protective Light
                  3523075121, // Extra Reserves
                  3523075122, // Precisely Charged
                  3523075123 // Stacks on Stacks
                ]
              },
              {
                name: "Season of the Worthy",
                items: [
                  179977568, // Grasp of the Warmind
                  2597888510, // Cellular Suppression
                  2597888511, // Power of Rasputin
                  2597888508, // Warmind's Protection
                  2597888509, // Warmind's Longevity
                  2597888506 // Light from Darkness
                ]
              },
              {
                name: "Season of Arrivals",
                items: [
                  2263321584, // Precision Charge
                  2263321585, // Surprise Attack
                  2263321586, // Energy Converter
                  2263321587 // Charge Harvester
                ]
              },
              {
                name: "Deep Stone Crypt",
                items: [
                  1362793604 // Enhanced Suppressor Augment
                ]
              },
              {
                name: "H.E.L.M.",
                items: [
                  240958661, // Reaping Wellmaker
                  3809244044, // Well of Tenacity
                  1358633824, // Well of Utility
                  1358633825 // Enduring Wells
                ]
              },
              {
                name: "Vault of Glass",
                items: [
                  518521232, // Precise Oracle Disruptor
                  518521233, // Vex Striker
                  518521234 // Superstructure Defender
                ]
              },
              {
                name: "Vow of the Disciple",
                items: [
                  1956421814, // Umbral Recharge
                  1098978103 // Distorted Glyphkeeper
                ]
              },
              {
                name: "King's Fall",
                items: [
                  852793406, // Will of Light (Void)
                ],
              },
            ]
          },
          {
            name: "Stasis",
            nameHash: 1819698290,
            itemGroups: [
              [
                1977242753, // Supreme Wellmaker
                1977242752, // Elemental Shards
                1977242755, // Well of Restoration
                1977242754 // Elemental Time Dilation
              ],
              [
                2779468392, // Siphoned Glyphkeeper
                899058084 // Stagnant Glyphkeeper
              ],
              [
                2074494595, // Will of Light (Stasis)
              ],
            ],
            groups: [
              {
                name: "H.E.L.M.",
                items: [
                  1977242753, // Supreme Wellmaker
                  1977242752, // Elemental Shards
                  1977242755, // Well of Restoration
                  1977242754 // Elemental Time Dilation
                ]
              },
              {
                name: "Vow of the Disciple",
                items: [
                  2779468392, // Siphoned Glyphkeeper
                  899058084 // Stagnant Glyphkeeper
                ]
              },
              {
                name: "King's Fall",
                items: [
                  2074494595, // Will of Light (Stasis)
                ],
              },
            ]
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/setData/modsGenerated.js